import { t } from "i18next";
import { getAttrLabelTreeData } from "src/common/attributes/makeAttrLabel/utils/getAttrLabelTreeData";
import { getLeaves } from "src/common/attributes/makeAttrLabel/utils/getLeaves";
import { zAttribute, ZAttribute } from "src/types/ZAttribute";
import { ZEntity } from "src/types/ZEntity";
import { ZGroup } from "src/types/ZGroup";
import { ZObjectItem } from "src/types/ZObjectItem";
import { ZOption } from "src/types/ZOption";
import { ZUid } from "src/types/zUid";
import { apiObjUrl } from "./apiUrl";
import { restWithObjectVersion } from "./restWithObjectVersion";

type ParamsEntityName = {
  entity: ZEntity;
  object: ZObjectItem;
  typesMap: Record<number, string>;
};

export const getEntityName = async (
  params: ParamsEntityName,
): Promise<string> => {
  const { entity, object } = params;
  const attr = findNameAttr(object);
  if (!attr) return t("Instance of object", { name: object.name });
  const nameAttr = entity.labelData?.attributes?.own.find(
    (a) => a.fieldKey === "NAME",
  );
  if (!nameAttr) return String(entity.id);
  const labelData4Name = getAttrLabelTreeData(
    nameAttr,
    entity.labelData?.labels || [],
  );
  if (!labelData4Name) return String(entity.id);

  const leaves = getLeaves(labelData4Name);
  return leaves.map((leaf) => leaf.labels?.join()).join();
};

export const findNameAttr = (object: ZObjectItem): ZAttribute | undefined =>
  findInAttrs(object.attributes) || findInGroups(object.groups);

const findInAttrs = (attrList?: ZAttribute[] | null): ZAttribute | undefined =>
  attrList?.find(({ fieldKey }) => fieldKey === "NAME");

const findInGroup = (group: ZGroup): ZAttribute | undefined =>
  findInAttrs(group.attributes) || findInGroups(group.groups);

const findInGroups = (groups?: ZGroup[] | null): ZAttribute | undefined => {
  if (groups) {
    // eslint-disable-next-line no-restricted-syntax
    for (const group of groups) {
      const attr = findInGroup(group);
      if (attr) return attr;
    }
  }
  return undefined;
};

export const loadRefOptions = async (
  referenceId: ZUid | null | undefined,
): Promise<ZOption[]> => {
  if (!referenceId) return [];
  const resp = await restWithObjectVersion.get(
    apiObjUrl(`/attributes/${referenceId}`),
    { translate: true },
  );
  const ref = zAttribute.parse(resp.data);
  return (
    ref.values?.map((a) => ({
      label: a.value || String(a.id),
      value: String(a.id),
    })) ?? []
  );
};
